import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            探索分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-lg mx-auto">
            六大分类，系统化构建你的女性生理健康知识体系
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-all duration-300"
            >
              <div className="relative h-40 md:h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-lg text-primary-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                      {cat.name}
                    </h3>
                    <span className="text-xs text-foreground-500">{cat.count} 个视频</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}